import classNames from "classnames";
import React, { HTMLAttributes } from "react";

import PanelBody from "./components/PanelBody";
import PanelFooter from "./components/PanelFooter";
import PanelHeader from "./components/PanelHeader";
import { StyledPanel } from "./Panel.styled";

type Props = HTMLAttributes<HTMLDivElement> & {
  /**
   * Set panel to be bordered
   */
  bordered?: boolean;

  /**
   * Set panel to be shadowed
   */
  shadowed?: boolean;
};

const defaultProps = {
  bordered: false,
  shadowed: false
};

const Panel = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { children, className, bordered, shadowed, ...restProps } = props;

  const panelClass = classNames("c-panel", bordered && "c-panel--bordered", shadowed && "c-panel--shadowed", className);

  return (
    <StyledPanel ref={ref} data-testid="qa-panel" className={panelClass} {...restProps}>
      {children}
    </StyledPanel>
  );
});

Panel.defaultProps = defaultProps;
Panel.displayName = "Panel";

export default Object.assign(Panel, {
  Header: PanelHeader,
  Body: PanelBody,
  Footer: PanelFooter
});
